import configureStore from 'redux/configStore';

export const { store, persistor } = configureStore(/* provide initial state if any */);
